import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { fetchSocialLinks, fetchBranding, fetchNavLinks, fetchGeneralSettings } from '../services/api';
import './Header.css';

const Header = () => {
  const [socialLinks, setSocialLinks] = useState([]);
  const [navLinks, setNavLinks] = useState([]);
  const [logoUrl, setLogoUrl] = useState('https://mobonus.com/wp-content/uploads/2025/11/Logo2.png');
  const [headerTitle, setHeaderTitle] = useState('MoBonus');
  const [headerSubtitle, setHeaderSubtitle] = useState('Compare the Best Casino Bonus Offers');
  const [bonusOffersLabel, setBonusOffersLabel] = useState('Bonus Offers');

  useEffect(() => {
    const loadData = async () => {
      const [links, branding, navigation, settings] = await Promise.all([
        fetchSocialLinks(),
        fetchBranding(),
        fetchNavLinks(),
        fetchGeneralSettings()
      ]);
      setSocialLinks(links);
      setNavLinks(navigation);
      setBonusOffersLabel(settings.bonusOffersLabel || 'Bonus Offers');
      if (branding.logoUrl) {
        setLogoUrl(branding.logoUrl);
      }
      if (branding.headerTitle) {
        setHeaderTitle(branding.headerTitle);
      }
      if (branding.headerSubtitle) {
        setHeaderSubtitle(branding.headerSubtitle);
      }
    };

    loadData();
  }, []);

  return (
    <motion.header
      className="header"
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
    >
      <div className="container">
        <div className="header-content">
          <div className="logo-section">
            <motion.div
              className="logo"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              <img src={logoUrl} alt={`${headerTitle} Logo`} className="logo-image" />
              <div className="logo-text">
                <h1>{headerTitle}</h1>
                <p className="header-subtitle">{headerSubtitle}</p>
              </div>
            </motion.div>
          </div>

          <nav className="header-nav">
            {navLinks.map((link) => (
              <motion.a
                key={link.id}
                href={link.url}
                className="nav-link"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                {link.iconUrl && link.showIcon && (
                  <img src={link.iconUrl} alt="" className="nav-link-icon" />
                )}
                {link.label === 'Bonus Offers' ? bonusOffersLabel : link.label}
              </motion.a>
            ))}

            {socialLinks.length > 0 && (
              <div className="social-links">
                {socialLinks.map((link) => (
                  <motion.a
                    key={link.id}
                    href={link.linkUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-link"
                    title={link.hoverText}
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                  >
                    <img src={link.iconUrl} alt={link.hoverText} />
                  </motion.a>
                ))}
              </div>
            )}
          </nav>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;
